var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.isEdit)?_c('color-text-btn',{staticClass:"filter-item line menu-btn-item",attrs:{"type":"primary"},on:{"click":_vm.to}},[_vm._v(" 校验组件 ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }